import { RowGroup } from './RowGroup'

export const TBodyCustom = ({
  ids,
  schema,
  selectRowGroup,
  selectCellData,
  isDynamicReport,
}) => {
  return (
    <tbody>
      {ids.map((rowId, index) => {
        return (
          <RowGroup
            key={rowId}
            schema={schema}
            rowId={rowId}
            rowGroupIndex={index}
            selectRowGroup={selectRowGroup}
            selectCellData={selectCellData}
            isDynamicReport={isDynamicReport}
          />
        )
      })}
    </tbody>
  )
}
